import { render, staticRenderFns } from "./AiSuggestion.vue?vue&type=template&id=6031bf28&scoped=true"
import script from "./AiSuggestion.vue?vue&type=script&lang=ts"
export * from "./AiSuggestion.vue?vue&type=script&lang=ts"
import style0 from "./AiSuggestion.vue?vue&type=style&index=0&id=6031bf28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031bf28",
  null
  
)

export default component.exports